import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CheckIcon, InstagramIcon, CreditCardIcon } from 'lucide-react';
const beneficios = ['Acceso total 3 meses a El Código del Dinero', 'Productos ganadores (con datos reales)', 'Tiendas + ofertas que convierten', 'Meta Ads para vender sin audiencia', 'Anuncios con IA (creativos que venden)', 'Envíos sin complicarte (sin empaquetar ni despachar)', 'Implementación + acompañamiento (7D + 90D)'];
export function OfferBlock() {
  return <section id="oferta" className="pt-6 pb-24 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto scroll-mt-10" data-id="element-70">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} className="bg-surface border border-primary/25 rounded-[2rem] relative overflow-hidden shadow-[0_0_80px_-20px_rgba(255,31,31,0.2)]" data-id="element-71">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-64 bg-primary/15 blur-[120px] -z-10 pointer-events-none" data-id="element-72" />

        <div className="relative" data-id="element-73">
          <img src="https://cdn.magicpatterns.com/uploads/7WE76qBrGRGDbeRrPCn4bY/code_of_money_202604041733.jpg" alt="Bundle El Código del Dinero" className="w-full h-auto" data-id="element-74" />
          <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-surface to-transparent" data-id="element-75" />
        </div>

        <div className="px-8 sm:px-12 pb-10 pt-4 text-center" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4" data-id="element-77">
            Deja de ser un espectador. Accede al Código.
          </h2>

          <p className="text-gray-400 font-medium mb-8" data-id="element-78">
            7 días de construcción intensiva + 3 meses (90 días) de
            acompañamiento estratégico.
          </p>

          <div className="mb-8 bg-[#0A0A0A] border border-primary/15 rounded-2xl p-6 sm:p-8 text-left max-w-lg mx-auto" data-id="element-79">
            <h3 className="text-lg font-bold text-white mb-5 text-center" data-id="element-80">
              Qué incluye tu acceso
            </h3>
            <ul className="space-y-3" data-id="element-81">
              {beneficios.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-82">
                  <CheckIcon className="w-4 h-4 text-gray-300 mt-0.5 flex-shrink-0" data-id="element-83" />
                  <span className="text-sm text-gray-300 font-medium leading-relaxed" data-id="element-84">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div id="precio" className="bg-background/80 border border-white/10 rounded-2xl p-6 mb-8 inline-block scroll-mt-20" data-id="element-85">
            <div className="flex flex-col items-center" data-id="element-86">
              <div className="flex items-baseline gap-2" data-id="element-87">
                <span className="text-5xl font-bold text-accent" data-id="element-88">$297</span>
                <span className="text-2xl font-bold text-accent" data-id="element-89">USD</span>
              </div>
              <span className="text-sm text-gray-300 mt-2 uppercase tracking-wider font-bold" data-id="element-90">
                Pago Único
              </span>
            </div>
          </div>

          <div data-id="element-91">
            <motion.a href="https://pay.hotmart.com/D105229507D?off=nw0e3326" target="_blank" rel="noopener noreferrer" animate={{
            boxShadow: ['0 0 20px -5px rgba(255,31,31,0.5)', '0 0 50px 5px rgba(255,31,31,0.7)', '0 0 20px -5px rgba(255,31,31,0.5)']
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} className="inline-flex items-center justify-center gap-2 sm:gap-3 w-full sm:w-auto px-6 sm:px-12 py-3.5 sm:py-5 text-sm sm:text-lg font-bold text-white bg-primary hover:bg-primaryHover rounded-xl transition-all duration-200 transform hover:scale-[1.02] text-center" data-id="element-92">
              <CreditCardIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-93" />
              Pagar con Tarjeta Crédito
            </motion.a>
            <motion.a href="https://www.instagram.com/lucastorresecom/" target="_blank" rel="noopener noreferrer" animate={{
            boxShadow: ['0 0 20px -5px rgba(16,185,129,0.5)', '0 0 50px 5px rgba(16,185,129,0.7)', '0 0 20px -5px rgba(16,185,129,0.5)']
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} className="inline-flex items-center justify-center gap-2 sm:gap-3 w-full sm:w-auto px-6 sm:px-12 py-3.5 sm:py-5 text-sm sm:text-lg font-bold text-white bg-emerald-600 hover:bg-emerald-500 rounded-xl transition-all duration-200 transform hover:scale-[1.02] text-center mt-3 sm:mt-4" data-id="element-94">
              <InstagramIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-95" />
              Para Pagar con USDT o Transferencia Enviame Mensaje
            </motion.a>
          </div>

          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-400 font-medium" data-id="element-96">
            <div className="flex items-center gap-2" data-id="element-97">
              <Lock className="w-4 h-4 text-primary" data-id="element-98" />
              <span data-id="element-99">Pago 100% Seguro</span>
            </div>
            <span className="hidden sm:inline text-white/20" data-id="element-100">•</span>
            <div className="flex items-center gap-2" data-id="element-101">
              <ShieldCheck className="w-4 h-4 text-primary" data-id="element-102" />
              <span data-id="element-103">Acceso Inmediato</span>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}